export const HIGHLIGHT_MAX = 100;
export const HIGHLIGHT_LIMIT = 10;

export type HighlightField = {
  id: string;
  text?: string;
};

export type SortableHighlightRowProps = {
  field: HighlightField;
  index: number;
  onRemove: (index: number) => void;
};
